import React, { useEffect, useState } from "react";
import { MuiTelInput } from "mui-tel-input";
import { CallAPI } from "../utils/apiActions";
import {
  getCurrencySymbol,
  getPriceAfterExchange,
  LABEL,
} from "../utils/constant";
import validationUtility from "../utils/Validation";
import { parsePhoneNumber } from "awesome-phonenumber";
import { showToast } from "../helper/toastHelper";
import { QUOTATION } from "../utils/APIEndPoints";
import {
  Link,
  useLocation,
  useSearchParams,
  useNavigate,
} from "react-router-dom";
import useDashboard from "../hooks/useDashboard";
import useAuth from "../hooks/useAuth";
import SplashScreen from "../components/SplashScreen";

const initState = {
  firstName: "",
  lastName: "",
  email: "",
  phone: "",
  notes: "",

  firstNameErr: "",
  lastNameErr: "",
  emailErr: "",
  phoneErr: "",
  notesErr: "",
};

const Pricing = () => {
  const navigate = useNavigate();
  const [formdata, setFormdata] = useState(initState);
  const [submissionLoader, setSubmissionLoader] = useState(false);
  const { planList, currencyRate, getAllPlan, setPlanPurchase } =
    useDashboard();
  const location = useLocation();
  const { user, defaultCountry, defaultCurrency } = useAuth();
  const [searchParams] = useSearchParams();
  const parentAgency = searchParams.get("agency") || null;

  const [planType, setPlanType] = useState(1); // 1 for montyly plan, 2 for yearly plan

  useEffect(() => {
    if (defaultCountry && defaultCurrency) {
      handleGetPlanListCountryWise();
    }
  }, [defaultCountry, defaultCurrency]);

  const handleGetPlanListCountryWise = async (plan) => {
    // const res = await fetch("https://ipapi.co/json/");
    // const data = await res.json();
    // const userCountry = data.country_name;
    getAllPlan(
      parentAgency,
      user?.country ??
        localStorage.getItem("country") ??
        defaultCountry ??
        "India",
    );
  };

  const handleGetPlan = (plan) => {
    setPlanPurchase(plan);
    setTimeout(() => {
      navigate("/signup?plan_id=" + plan.id);
    }, 100);
  };

  const onSubmit = async () => {
    setSubmissionLoader(true);
    let loItem = { ...formdata };
    let flag = true;
    let mandetoryField = [
      { key: "firstName", value: "First Name" },
      { key: "lastName", value: "Last Name" },
      { key: "email", value: "Email" },
      // { key: "phone", value: "Phone Number" },
      { key: "notes", value: "Notes" },
    ];
    mandetoryField.map((field, ind) => {
      if (
        formdata[field.key] == null ||
        formdata[field.key] == "" ||
        formdata[field.key] == undefined
      ) {
        flag = false;
        loItem[field.key + "Err"] = `${field.value} is required`;
      }
      if (
        field.key == "email" &&
        !!formdata.email &&
        !validationUtility.email(formdata.email.trim())
      ) {
        flag = false;
        loItem.emailErr = "Not a valid email";
      }
      // if (
      //   field.key == "phone" &&
      //   !!formdata.phone &&
      //   !parsePhoneNumber(`${formdata.phone}`).valid
      // ) {
      //   flag = false;
      //   loItem.phoneErr = "Not a valid phone number";
      // }
    });
    if (formdata.phone && !parsePhoneNumber(`${formdata.phone}`).valid) {
      flag = false;
      loItem.phoneErr = "Not a valid phone number";
    }
    setFormdata(loItem);
    if (!!flag) {
      let body = {
        firstName: formdata.firstName,
        lastName: formdata.lastName,
        email: formdata.email,
        phone: formdata.phone.replaceAll(" ", ""),
        notes: formdata.notes,
      };
      let response = await CallAPI("USER", "POST", QUOTATION, body);
      if (response.status) {
        showToast(response.msg, LABEL.TOAST_TYPE.SUCCESS);
        setFormdata(initState);
      } else {
        showToast(response.msg, LABEL.TOAST_TYPE.ERROR);
      }
    }
    setSubmissionLoader(false);
  };

  const handleChangeForndata = (e) => {
    setFormdata({
      ...formdata,
      [e.target.name]: e.target.value,
      [e.target.name + "Err"]: e.target.value
        ? ""
        : camelCaseToLabel(e.target.name) + " is required",
    });
  };

  function camelCaseToLabel(str) {
    return str
      .replace(/([A-Z])/g, " $1") // Add space before capital letters
      .replace(/^./, (char) => char.toUpperCase()); // Capitalize first letter
  }

  // console.log("===========>", planList)
  const filteredPlans = planList?.filter((plan) => planType === plan.planType);

  return (
    <section className="body-wrap">
      <div className="contact-grid">
        {planList.length > 0 ? (
          <div className="bot-pricing-grid">
            <div className="bot-pricing_list">
              <div className="container">
                <div className="row">
                  <div className="container text-center mb-4">
                    <div className="row justify-content-center">
                      {/* Row 1 - Title */}
                      <div className="col-12 mb-2">
                        <h3>
                          BottBuddy powered by T-Web Exponent Services Private
                          Limited
                        </h3>
                      </div>

                      {/* Row 2 - Subtitle */}
                      <div className="col-12 mb-3">
                        <h4>Pricing Plans</h4>
                      </div>

                      {/* Row 3 - Tabs */}
                      <div className="col-auto">
                        <ul className="nav nav-pills pricing-tabs justify-content-center">
                          <li className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${planType === 1 ? "active" : ""}`}
                              onClick={() => setPlanType(1)}
                            >
                              Monthly
                            </button>
                          </li>

                          <li className="nav-item">
                            <button
                              type="button"
                              className={`nav-link ${planType === 2 ? "active" : ""}`}
                              onClick={() => setPlanType(2)}
                            >
                              Yearly
                            </button>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="row">
                  {filteredPlans?.map((plan) => (
                    <div
                      key={plan.id}
                      id={plan.id}
                      className="col-md-4 mb--30"
                      style={{
                        ...([744, 738, 759].includes(plan.id) && {
                          display: "none",
                        }),
                      }}
                    >
                      <div
                        className={`pricing-plan ${
                          plan.userType === 3
                            ? "annualAgencyPlan"
                            : "businessPlan"
                        }`}
                      >
                        {/* <div className="highlight-plan-name">
                          {plan.userType === 3 ? <i className="fa-solid fa-user-secret"></i> : <i className="fa-solid fa-user"></i>}
                          <h6>{plan.userType === 3 ? "Agency Plan" : "Subscriber Plan"}</h6>
                        </div> */}
                        <div className="top-header">
                          <h5>{plan.planName || ""}</h5>
                          {/* <p>Ideal for businesses seeking to
                                      enhance customer interactions
                                      with a versatile chatbot widget
                                      for support, sales, and
                                      information.</p> */}
                        </div>
                        {plan.price > 0 ? (
                          <div className="plan-month">
                            {user
                              ? getCurrencySymbol(user?.currency)
                              : getCurrencySymbol(
                                  localStorage.getItem("currency"),
                                )}
                            <span>
                              {getPriceAfterExchange(
                                plan.price,
                                user?.currency,
                                currencyRate,
                              )}
                            </span>
                            {planType == 1 ? " / month" : " / year"}
                          </div>
                        ) : (
                          <div className="free-plan-forever">Free Forever</div>
                        )}

                        <div className="bot-plan-messages mb--10">
                          <span>Messages</span>{" "}
                          <span>
                            {plan.messageCount}{" "}
                            {!!plan.isFreePlan
                              ? ""
                              : planType == 1
                                ? " / month"
                                : " / year"}
                          </span>
                        </div>
                        <div className="bot-plan-bots mb--10">
                          <span>Bots</span>{" "}
                          <span>
                            {plan?.noOfBots >= 100000
                              ? "UNLIMITED"
                              : plan?.noOfBots}
                          </span>
                        </div>
                        <div className="get-it-button mt--50">
                          <Link
                            to={"#"}
                            onClick={() => handleGetPlan(plan)}
                            className="cta-primary"
                          >
                            GET IT NOW
                          </Link>
                        </div>
                        <div className="plan-lists mt--50">
                          <ul>
                            {plan?.module?.map((module) => (
                              <li key={module.id}>
                                {module.moduleDescription.description || ""}
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <SplashScreen />
        )}

        {/* Frequently Asked Questions */}
        <div className="container mt-5">
          <h2 className="text-center mb-4">Frequently Asked Questions</h2>
          <div className="accordion" id="faqAccordion">
            <div className="accordion-item">
              <h2 className="accordion-header" id="faqHeadingOne">
                <button
                  className="accordion-button"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqCollapseOne"
                  aria-expanded="true"
                  aria-controls="faqCollapseOne"
                >
                  1. What counts as a “message”?
                </button>
              </h2>
              <div
                id="faqCollapseOne"
                className="accordion-collapse collapse show"
                aria-labelledby="faqHeadingOne"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Each reply generated by the BottBuddy AI chatbot counts as one
                  message, regardless of length. There is no word limit per
                  response.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="faqHeadingTwo">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqCollapseTwo"
                  aria-expanded="false"
                  aria-controls="faqCollapseTwo"
                >
                  2. Are messages counted after a human takes over the chat?
                </button>
              </h2>
              <div
                id="faqCollapseTwo"
                className="accordion-collapse collapse"
                aria-labelledby="faqHeadingTwo"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  No. Once a conversation is transferred to a human agent using
                  the Human Takeover feature, messages are no longer deducted
                  from your monthly/yearly quota.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="faqHeadingThree">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqCollapseThree"
                  aria-expanded="false"
                  aria-controls="faqCollapseThree"
                >
                  3. What happens if I reach my monthly message limit?
                </button>
              </h2>
              <div
                id="faqCollapseThree"
                className="accordion-collapse collapse"
                aria-labelledby="faqHeadingThree"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  If you reach your plan’s message limit, AI responses will
                  pause temporarily. You can either wait for the next billing
                  cycle, upgrade to a higher plan, or purchase additional
                  message add-ons to continue conversations without
                  interruption.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="faqHeadingFour">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqCollapseFour"
                  aria-expanded="false"
                  aria-controls="faqCollapseFour"
                >
                  4. Can I upgrade my plan anytime?
                </button>
              </h2>
              <div
                id="faqCollapseFour"
                className="accordion-collapse collapse"
                aria-labelledby="faqHeadingFour"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes. You can upgrade at any time as your business grows. Your
                  new message limits and bot capacity will be available
                  immediately after upgrading.
                </div>
              </div>
            </div>

            <div className="accordion-item">
              <h2 className="accordion-header" id="faqHeadingFive">
                <button
                  className="accordion-button collapsed"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#faqCollapseFive"
                  aria-expanded="false"
                  aria-controls="faqCollapseFive"
                >
                  5. Does BottBuddy support multiple languages?
                </button>
              </h2>
              <div
                id="faqCollapseFive"
                className="accordion-collapse collapse"
                aria-labelledby="faqHeadingFive"
                data-bs-parent="#faqAccordion"
              >
                <div className="accordion-body">
                  Yes. BottBuddy offers multilingual AI processing and a
                  language selection option, allowing businesses to support
                  customers in multiple languages.
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="container">
          <div className="banner-home_text with-h1-line text-center pt-5">
            <h1>Ask For Enterprise Plan Pricing</h1>
          </div>

          <div className="contact-form box-border">
            <div className="row">
              <div className="col-xl-12">
                <div className="field">
                  <input
                    type="text"
                    className="form-control"
                    id="txtName"
                    placeholder="Enter Your First Name *"
                    name="firstName"
                    value={formdata.firstName}
                    onChange={handleChangeForndata}
                  />
                  {formdata.firstNameErr && (
                    <span className="invalid-feedback">
                      {formdata.firstNameErr}
                    </span>
                  )}
                </div>
                <div className="field">
                  <input
                    type="text"
                    className="form-control"
                    id="txtName"
                    placeholder="Enter Your Last Name *"
                    name="lastName"
                    value={formdata.lastName}
                    onChange={handleChangeForndata}
                  />
                  {formdata.lastNameErr && (
                    <span className="invalid-feedback">
                      {formdata.lastNameErr}
                    </span>
                  )}
                </div>
                <div className="field">
                  <input
                    type="email"
                    className="form-control"
                    id="txtEmail"
                    placeholder="Enter Your Email *"
                    name="email"
                    value={formdata.email}
                    onChange={handleChangeForndata}
                  />
                  {formdata.emailErr && (
                    <span className="invalid-feedback">
                      {formdata.emailErr}
                    </span>
                  )}
                </div>
                <div className="field">
                  <MuiTelInput
                    id="full-width-text-field-mobile"
                    fullWidth={true}
                    variant="outlined"
                    forceCallingCode
                    defaultCountry="IN"
                    enableLongNumbers={true}
                    autoFormat={false}
                    disableAreaCodes={true}
                    countryCodeEditable={false}
                    autoComplete="off"
                    className="customtel"
                    value={formdata.phone}
                    error={!!formdata.phoneErr}
                    helperText={formdata.phoneErr}
                    placeholder="Enter Your Phone Number"
                    onChange={(value) => {
                      setFormdata({
                        ...formdata,
                        phone: value,
                        phoneErr: value ? "" : "Phone Number is required",
                      });
                    }}
                  />
                </div>

                <div className="field">
                  <textarea
                    className="form-control"
                    id="exampleFormControlTextarea1"
                    rows="5"
                    name="notes"
                    placeholder="Enter Your Notes *"
                    value={formdata.notes}
                    onChange={handleChangeForndata}
                  ></textarea>
                  {formdata.notesErr && (
                    <span className="invalid-feedback">
                      {formdata.notesErr}
                    </span>
                  )}
                </div>
              </div>

              <div className="col-12 text-center">
                <button className="cta-dark" type="button" onClick={onSubmit}>
                  {submissionLoader && (
                    <i className="fa-solid fa-spinner fa-spin"></i>
                  )}
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Pricing;
